import React, { useRef } from 'react'
import { connect } from 'react-redux'
import '../../styles/scss/components/equote-agent-details-footer.scss'
import { updateCurrentAppStep } from '../../actions/appState'
import EQuoteAgentAccoladeAwardDetail from './EQuoteAgentAccoladeDetail'
import EQuoteAgentDetailsBanner from './EQuoteAgentDetailsBanner'
import triggerCustomGaEvent from '../../utils/triggerCustomGaEvent'

import BestEurope from '../../assets/images/celebrity-best-europe.png'

const EQuoteAgentDetailsFooter = props => {
  const { agency, agent, brandClassName } = props
  const agentDetailRef = useRef()

  const handleShowAgentDetailBanner = e => {
    agentDetailRef.current.classList.toggle('show')
    agentDetailRef.current.classList.contains('show')
      ? (e.target.innerHTML = 'Close X')
      : (e.target.innerHTML = 'Agent Info')

    window.setTimeout(() => {
      agentDetailRef.current.scrollIntoView()
    }, 270)
  }

  const handleGoToNextStep = () => {
    props.goToNextStep(props.currentStep)
    triggerCustomGaEvent('sailingPreview-requestSailing')
    window.scrollTo(0, 0)
  }

  return (
    <div className="equote-agent-footer" id="request">
      <div className="equote-agent-footer--accolades">
        {props.brandClassName !== 'default' && (
          <div className="equote-agent-footer--accolades-wrapper">
            {brandClassName === 'celebrity' && (
              <div className="equote-agent-accolade--black">
                <EQuoteAgentAccoladeAwardDetail>
                  <>
                    <h3>2020 GOLD AWARD</h3>
                    <h1>
                      BEST PREMIUM
                      <br />
                      CRUISE SHIP
                    </h1>
                    <h3>Celebrity Edge</h3>
                    <p>Travvy Awards</p>
                  </>
                </EQuoteAgentAccoladeAwardDetail>
                <>
                  <img
                    src={BestEurope}
                    alt="Best Europe"
                    style={{ height: '150px', width: '200px' }}
                  />
                </>
                <EQuoteAgentAccoladeAwardDetail>
                  <>
                    <h3>2020 GOLD AWARD</h3>
                    <h1>
                      BEST PREMIUM
                      <br />
                      CRUISE SHIP
                    </h1>
                    <h3>Celebrity Cruises</h3>
                    <p>Travvy Awards</p>
                  </>
                </EQuoteAgentAccoladeAwardDetail>
              </div>
            )}
            {brandClassName === 'royal' && (
              <div className="equote-agent-accolade--blue">
                <EQuoteAgentAccoladeAwardDetail>
                  <>
                    <h1>
                      BEST CRUISE LINE{' '}
                      <span>
                        <small>IN</small>
                        <small>THE</small>
                      </span>{' '}
                      CARIBBEAN
                    </h1>
                    <h3>SINCE 2003</h3>
                    <p>Travel Weekly Reader's Choice Award</p>
                  </>
                </EQuoteAgentAccoladeAwardDetail>
                <div className="equote-agent-accolade-text">
                  BEST CRUISE LINE SINCE 2003
                </div>
                <EQuoteAgentAccoladeAwardDetail>
                  <>
                    <h1>BEST CRUISE LINE OVERALL</h1>
                    <h3>SINCE 2003</h3>
                    <p>Travel Weekly Reader's Choice Award</p>
                  </>
                </EQuoteAgentAccoladeAwardDetail>
              </div>
            )}
          </div>
        )}
      </div>
      <div className="u-content-container">
        <div className="equote-agent-footer--header">
          <h1 className={`section-title ${brandClassName} u-text-center`}>
            Start Planning Your Vacation
          </h1>
          <p>Contact me to confirm your cruise and get sailing.</p>
          <div className="equote-agent-footer--header-buttons-wrapper">
            <EQuoteAgentDetailsBanner
              {...props}
              ref={agentDetailRef}
              agencyImage={
                agency && agency.logo && agency.logo['agency-logo']
                  ? agency.logo['agency-logo']
                  : null
              }
            />
            <div className="equote-agent-footer--header-buttons">
              <button
                className="btn btn-info btn-agent-info u-uppercase"
                onClick={handleShowAgentDetailBanner}
              >
                Agent Info
              </button>
              <button
                className="btn btn-primary btn-more-info u-uppercase"
                onClick={handleGoToNextStep}
              >
                Request This Sailing
              </button>
            </div>
          </div>
        </div>
        <div className="equote-agent-footer--inner">
          {agency && agency.name && agency.logo && agency.logo['agency-logo'] && (
            <div className="equote-agent-footer-agency-logo">
              <img src={agency.logo['agency-logo']} alt="eQuote" />
            </div>
          )}

          <div className="equote-agent-footer--names">
            {agent && agent.name && (
              <div className="item u-flex-container--center">
                <p className="item--title u-remove-margin">Agent Name</p>
                <p className="item--info u-remove-margin">{agent.name}</p>
              </div>
            )}

            {agency && agency.name && (
              <div className="item u-flex-container--center">
                <p className="item--title u-remove-margin">Agency</p>
                <p className="item--info u-remove-margin">{agency.name}</p>
              </div>
            )}
          </div>

          <div>
            {props.agent && props.agent.email && (
              <div className="item u-flex-container--center">
                <p className="item--title u-remove-margin">Email</p>
                <p className="item--info u-remove-margin">
                  {props.agent.email}
                </p>
              </div>
            )}
            {props.agency && props.agency.phone && (
              <div className="item u-flex-container--center">
                <p className="item--title u-remove-margin">Phone</p>
                <p className="item--info u-remove-margin">
                  {props.agency.phone}
                </p>
              </div>
            )}
            {props.agency && agency.website && (
              <div className="item u-flex-container--center">
                <p className="item--title u-remove-margin">Website</p>
                <p className="item--info u-remove-margin">
                  <a
                    target="_blank"
                    href={
                      agency.website.includes('http://') ||
                      agency.website.includes('https://')
                        ? agency.website
                        : `http://${agency.website}`
                    }
                    rel="noopener noreferrer"
                  >
                    {agency.website}
                  </a>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  agent: state.agencyDetails.agent,
  agency: state.agencyDetails.agency,
  currentStep: state.appState.currentStep
})

const mapDispatchToProps = dispatch => ({
  goToNextStep(currentStep) {
    dispatch(updateCurrentAppStep(currentStep + 1))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EQuoteAgentDetailsFooter)
